module.exports = __webpack_public_path__ + "static/media/tinywow_Phleumprat.2700_colored_55476120.d07eb72e.jpg";